<form nz-form class="form" [formGroup]="reviewForm">
  <div class="title-wrapper mb-16">
    <h3 class="title s-16">Corrections Requested From</h3>
  </div>
  <nz-form-item>
    <nz-form-label nzFor="userVendor"
      >{{ userData?.fullName ?? '-' }}
    </nz-form-label>
    <nz-form-control>
      <textarea
        disabled="true"
        id="userVendor"
        name="userVendor"
        nz-input
        [value]="reviewForm.value.adminNotes">
      </textarea>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label nzFor="userVendor" nzRequired>
      Add notes to email ({{ userData?.email ?? '-' }})
    </nz-form-label>
    <nz-form-control>
      <textarea
        id="userNote"
        name="userNote"
        nz-input
        formControlName="userNotes"
        rows="4"
        maxlength="5000">
      </textarea>
      <div class="mt-3 remaining-text">
        {{ reviewForm.value.userNotes?.length || 0 }} of 5000 characters used
      </div>
      <div
        class="ant-form-item-explain-error mt-3"
        *ngIf="reviewForm.get('userNotes')?.errors?.['required']">
        Please enter your notes.
      </div>
      <div
        class="ant-form-item-explain-error mt-3"
        *ngIf="reviewForm.get('userNotes')?.errors?.['maxlength']">
        Note cannot exceed 5000 characters.
      </div>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <span
      nz-checkbox
      class="with-tooltip"
      [nzChecked]="
        reviewForm.value.reviewStatusId === reviewStatus['Changes Received']
      "
      (nzCheckedChange)="onCheckBoxChange($event)">
      Changes Applied
      <svg-icon
        nz-tooltip
        nzTooltipTitle="Please check box when changes have been made"
        src="/assets/icon/icon-help.svg"
        class="icon s-16"
        aria-label="Help">
      </svg-icon>
    </span>
  </nz-form-item>
</form>
